// extracted by mini-css-extract-plugin
export default {"card":"GridItem_card__ZCUTp","section":"GridItem_section__p8EAT","like":"GridItem_like__WnofW","label":"GridItem_label__65Cwz"};